import { useLingui } from '@lingui/react/macro';
import { enUS, frCA } from 'date-fns/locale';

export const FRENCH_LOCALES = ['fr', 'fr-CA', 'zu-ZA'] as string[];

export const useGetDateFNSLocale = () => {
  const { i18n } = useLingui();

  return FRENCH_LOCALES.includes(i18n.locale) ? frCA : enUS;
};
